import DapDSCard from './card.component'

export * from './card.component'
export default DapDSCard

DapDSCard.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-card': DapDSCard
  }
}
